<template>
  <span
    :class="[
      '-insert-your-own-gap',
      '-gap',
      'wt2-link',
      guid,
      { '-irrelevant': !isRelevant, '-singleGap': isSingleGap },
    ]"
    @click="onClick"
    :title="text"
    v-text="text"
  ></span>
</template>

<script>
export default {
  name: 'wt-transcribe-your-own-gap',
  props: {
    tokenData: {
      type: Object,
      required: true,
    },
    tokenIndex: {
      type: Number,
      required: true,
    },
    isRelevant: {
      type: Boolean,
      required: true,
    },
    isSingleGap: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      guid: app.guid(),
      text: app.culture.get('transcribe.insertYourOwn'),
    };
  },
  mounted() {
    this.$el._tokenData = this.tokenData;
    this.$el._tokenIndex = this.tokenIndex;
  },
  beforeDestroy() {},
  methods: {
    onClick() {
      this.$emit('click', {
        tokenData: this.tokenData,
        tokenIndex: this.tokenIndex,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.-insert-your-own-gap {
  position: relative;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;

  &.-highlight {
    background-color: transparent !important;
  }
}
</style>
